/* Original line-art SVG icons — gold stroke, kumkum-red details */
const G = "#A8722A";
const R = "#B23A2B";
const GR = "#3E6B4F";

const Svg = ({ children, label, size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" role="img" aria-label={label}
    stroke={G} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

export const KalashaIcon = (p) => (
  <Svg label="Kalasha" {...p}>
    <path d="M16 20c-2 3-3 6-3 9 0 7 5 11 11 11s11-4 11-11c0-3-1-6-3-9" />
    <path d="M15 20h18M17 16h14M19 16v-3h10v3" />
    <path d="M24 13c0-3 1.5-5 4-6M24 13c0-3-1.5-5-4-6M24 13V7" />
    <circle cx="24" cy="30" r="2.4" fill={R} stroke="none" />
  </Svg>
);

export const CradleIcon = (p) => (
  <Svg label="Cradle" {...p}>
    <path d="M10 18h28M12 18v10a10 10 0 0 0 24 0V18" />
    <path d="M10 12l4 6M38 12l-4 6" />
    <path d="M14 42c4-3 16-3 20 0" />
    <path d="M24 38v-1" />
    <circle cx="24" cy="27" r="3" />
    <circle cx="24" cy="23.4" r="1" fill={R} stroke="none" />
  </Svg>
);

export const GarlandsIcon = (p) => (
  <Svg label="Twin garlands" {...p}>
    <path d="M12 8c-4 8-4 18 0 26M20 8c4 8 4 18 0 26" />
    <path d="M28 8c-4 8-4 18 0 26M36 8c4 8 4 18 0 26" />
    <circle cx="16" cy="38" r="2.4" fill={R} stroke="none" />
    <circle cx="32" cy="38" r="2.4" fill={R} stroke="none" />
    <circle cx="16" cy="10" r="1.2" /><circle cx="32" cy="10" r="1.2" />
  </Svg>
);

export const ThreadIcon = (p) => (
  <Svg label="Sacred thread" {...p}>
    <path d="M24 6C13 10 9 20 12 30c2 7 8 12 12 12s10-5 12-12c3-10-1-20-12-24z" />
    <path d="M24 6C17 12 15 24 18 34M24 6c7 6 9 18 6 28" />
    <circle cx="24" cy="40" r="2.4" fill={R} stroke="none" />
  </Svg>
);

export const RingsPlateIcon = (p) => (
  <Svg label="Rings on plate" {...p}>
    <ellipse cx="24" cy="34" rx="18" ry="6" />
    <circle cx="19" cy="24" r="6" />
    <circle cx="29" cy="24" r="6" />
    <path d="M19 18l1.6-3h-3.2z" fill={R} stroke={R} />
    <path d="M29 18l1.6-3h-3.2z" fill={R} stroke={R} />
  </Svg>
);

export const TwinKalashaIcon = (p) => (
  <Svg label="Twin kalashas" {...p}>
    <path d="M8 26c-1 2-2 4-2 6 0 5 4 8 8 8s8-3 8-8c0-2-1-4-2-6M7 26h14M9 22h10M14 22v-4" />
    <path d="M28 26c-1 2-2 4-2 6 0 5 4 8 8 8s8-3 8-8c0-2-1-4-2-6M27 26h14M29 22h10M34 22v-4" />
    <circle cx="14" cy="13" r="2" fill={R} stroke="none" />
    <circle cx="34" cy="13" r="2" fill={R} stroke="none" />
    <path d="M14 18c0-2 1-3 2-4M34 18c0-2-1-3-2-4" />
  </Svg>
);

export const KathaBookIcon = (p) => (
  <Svg label="Katha book" {...p}>
    <path d="M24 12c-4-3-10-4-16-3v26c6-1 12 0 16 3 4-3 10-4 16-3V9c-6-1-12 0-16 3z" />
    <path d="M24 12v26" />
    <path d="M12 17h7M12 22h7M29 17h7M29 22h7" />
    <circle cx="24" cy="8" r="1.8" fill={R} stroke="none" />
  </Svg>
);

export const LingaIcon = (p) => (
  <Svg label="Shiva linga with abhisheka drops" {...p}>
    <path d="M17 30V18a7 7 0 0 1 14 0v12" />
    <path d="M10 32c0-2 6-4 14-4s14 2 14 4-6 5-14 5-14-3-14-5z" />
    <path d="M24 6v3M24 9c-.8 1.4-.8 2.4 0 3.6.8-1.2.8-2.2 0-3.6z" fill={R} stroke={R} strokeWidth="1" />
    <path d="M19 14c1.5 1 8.5 1 10 0" stroke={R} />
  </Svg>
);

export const ShopToranIcon = (p) => (
  <Svg label="Shop with toran" {...p}>
    <path d="M8 18l3-8h26l3 8M10 18v20h28V18" />
    <path d="M8 18h32" />
    <path d="M20 38V28h8v10" />
    <path d="M12 20l2 3 2-3 2 3 2-3M28 20l2 3 2-3 2 3 2-3" stroke={GR} />
    <circle cx="24" cy="23" r="1.6" fill={R} stroke="none" />
  </Svg>
);

export const DiyaIcon = (p) => (
  <Svg label="Diya lamp" {...p}>
    <path d="M10 30c2 6 8 9 14 9s12-3 14-9c-9 3-19 3-28 0z" />
    <path d="M8 30c5 2 27 2 32 0" />
    <path d="M24 26c-3-3-3-7 0-11 3 4 3 8 0 11z" fill={R} stroke={R} strokeWidth="1" />
    <path d="M24 15v-3" />
  </Svg>
);

export const VehicleIcon = (p) => (
  <Svg label="Vehicle" {...p}>
    <path d="M8 30l4-9c.5-1 1.5-2 3-2h18c1.5 0 2.5 1 3 2l4 9" />
    <path d="M6 30h36v6h-4M10 36H6v-6" />
    <circle cx="14" cy="36" r="3.5" /><circle cx="34" cy="36" r="3.5" />
    <path d="M18 36h12" />
    <circle cx="24" cy="15" r="2" fill={R} stroke="none" />
    <path d="M24 25v-4" stroke={R} />
  </Svg>
);

export const BellIcon = (p) => (
  <Svg label="Temple bell" {...p}>
    <path d="M24 8c-7 0-11 6-11 13v6l-3 5h28l-3-5v-6c0-7-4-13-11-13z" />
    <path d="M24 8V5M21 37a3 3 0 0 0 6 0" />
    <circle cx="24" cy="42" r="2" fill={R} stroke="none" />
  </Svg>
);

export const HomaFlameIcon = (p) => (
  <Svg label="Homa fire" {...p}>
    <path d="M10 38h28M13 38l4-6h14l4 6" />
    <path d="M24 30c-5-4-6-9-2-15 0 3 1.5 4.5 3 5-1-4 0-8 4-11-1 5 2 7 3 10 1.5 4 0 8-4 11" />
    <circle cx="24" cy="25" r="1.8" fill={R} stroke="none" />
  </Svg>
);

export const NineDotIcon = (p) => (
  <Svg label="Navagraha mandala" {...p}>
    <circle cx="24" cy="24" r="17" />
    <circle cx="24" cy="24" r="3" fill={R} stroke="none" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
      <circle key={a} cx={24 + 11 * Math.cos((a * Math.PI) / 180)} cy={24 + 11 * Math.sin((a * Math.PI) / 180)} r="2" />
    ))}
  </Svg>
);

export const ChakraIcon = (p) => (
  <Svg label="Sudarshana chakra" {...p}>
    <circle cx="24" cy="24" r="15" />
    <circle cx="24" cy="24" r="5" />
    {[0, 30, 60, 90, 120, 150].map((a) => {
      const x = Math.cos((a * Math.PI) / 180), y = Math.sin((a * Math.PI) / 180);
      return <path key={a} d={`M${24 - 15 * x} ${24 - 15 * y}L${24 + 15 * x} ${24 + 15 * y}`} />;
    })}
    <circle cx="24" cy="24" r="2" fill={R} stroke="none" />
  </Svg>
);

export const TrishulaFlameIcon = (p) => (
  <Svg label="Mrityunjaya" {...p}>
    <path d="M24 42V20" />
    <path d="M14 10c0 8 4 12 10 12s10-4 10-12" />
    <path d="M24 22V8" />
    <path d="M20 38c-3-3-3-6-1-9 .5 2 1.5 3 3 3.5" stroke={R} />
    <path d="M28 38c3-3 3-6 1-9-.5 2-1.5 3-3 3.5" stroke={R} />
  </Svg>
);

export const DeviFlameIcon = (p) => (
  <Svg label="Chandi homa" {...p}>
    <path d="M24 40c-8-5-9-12-3-20 0 4 2 6 4 7-1.5-6 0-11 5-15-1 7 3 9 4 13 2 6-2 12-10 15z" />
    <path d="M18 14l-2-4M30 12l3-4" />
    <circle cx="24" cy="30" r="2" fill={R} stroke="none" />
  </Svg>
);

export const CoinPotIcon = (p) => (
  <Svg label="Coin pot" {...p}>
    <path d="M14 22c-2 3-3 6-3 9 0 6 5 10 13 10s13-4 13-10c0-3-1-6-3-9" />
    <path d="M13 22h22M15 18h18" />
    <circle cx="20" cy="14" r="3" /><circle cx="28" cy="14" r="3" /><circle cx="24" cy="10" r="3" />
    <circle cx="24" cy="31" r="2.2" fill={R} stroke="none" />
  </Svg>
);

export const OrbitIcon = (p) => (
  <Svg label="Planetary orbit" {...p}>
    <circle cx="24" cy="24" r="5" />
    <ellipse cx="24" cy="24" rx="18" ry="8" />
    <ellipse cx="24" cy="24" rx="18" ry="8" transform="rotate(60 24 24)" />
    <circle cx="40" cy="19" r="2.2" fill={R} stroke="none" />
    <circle cx="13" cy="36" r="1.8" />
  </Svg>
);

export const JapaBeadsIcon = (p) => (
  <Svg label="Japa mala" {...p}>
    <circle cx="24" cy="22" r="14" strokeDasharray="0.1 6.2" strokeWidth="3.4" />
    <path d="M24 36v4" />
    <path d="M21 42.5c1-2 5-2 6 0" />
    <circle cx="24" cy="41" r="2.2" fill={R} stroke="none" />
  </Svg>
);

export const HomeOmIcon = (p) => (
  <Svg label="Home with om" {...p}>
    <path d="M8 22L24 8l16 14M12 20v18h24V20" />
    <text x="24" y="33" textAnchor="middle" fontSize="12" fill={R} stroke="none" fontFamily="serif">ॐ</text>
  </Svg>
);

export const IshtalingaIcon = (p) => (
  <Svg label="Ishtalinga" {...p}>
    <path d="M24 10c6 0 10 4 10 9 0 4-3 7-5 8h-10c-2-1-5-4-5-8 0-5 4-9 10-9z" />
    <path d="M17 27h14l2 6c.5 2-1 4-3 4H18c-2 0-3.5-2-3-4z" />
    <path d="M24 10V6" />
    <circle cx="24" cy="19" r="2.2" fill={R} stroke="none" />
  </Svg>
);

export const ShikharaIcon = (p) => (
  <Svg label="Temple shikhara" {...p}>
    <path d="M24 5l-8 14h16z" />
    <path d="M13 19h22l-3 8H16z" />
    <path d="M12 27h24v6H12zM10 33h28v6H10z" />
    <circle cx="24" cy="12" r="1.6" fill={R} stroke="none" />
  </Svg>
);

export const SmarthaIcon = (p) => (
  <Svg label="Panchayatana" {...p}>
    <rect x="10" y="10" width="28" height="28" rx="4" />
    <circle cx="24" cy="24" r="3" fill={R} stroke="none" />
    <circle cx="16" cy="16" r="2" /><circle cx="32" cy="16" r="2" />
    <circle cx="16" cy="32" r="2" /><circle cx="32" cy="32" r="2" />
  </Svg>
);

export const MadhwaIcon = (p) => (
  <Svg label="Gopichandana" {...p}>
    <path d="M18 8v26M30 8v26" />
    <path d="M24 14v18" stroke={R} />
    <path d="M14 38c4 3 16 3 20 0" />
    <circle cx="24" cy="10" r="1.8" fill={R} stroke="none" />
  </Svg>
);

export const NamamIcon = (p) => (
  <Svg label="Srivaishnava namam" {...p}>
    <path d="M14 8c-2 12 0 22 4 30M34 8c2 12 0 22-4 30" />
    <path d="M24 16v22" stroke={R} />
    <path d="M18 38h12" />
  </Svg>
);

export const SimpleHavanIcon = (p) => (
  <Svg label="Simple havan" {...p}>
    <path d="M12 36h24M15 36l3-5h12l3 5" />
    <path d="M24 28c-3-3-3-6 0-10 3 4 3 7 0 10z" fill="none" />
    <circle cx="24" cy="23" r="1.6" fill={R} stroke="none" />
    <path d="M10 42h28" />
  </Svg>
);

export const VidhanaSoudhaIcon = ({ className }) => (
  <svg viewBox="0 0 200 90" fill="none" stroke={G} strokeWidth="1.8" strokeLinecap="round"
    className={className} role="img" aria-label="Vidhana Soudha line art">
    <path d="M100 8c-8 6-12 12-12 18h24c0-6-4-12-12-18z" />
    <path d="M84 26h32v8H84z" />
    <circle cx="100" cy="6" r="2" fill={R} stroke="none" />
    <path d="M30 42c-5 3-7 7-7 10h14c0-3-2-7-7-10zM170 42c-5 3-7 7-7 10h14c0-3-2-7-7-10z" />
    <path d="M20 52h20v6H20zM160 52h20v6h-20z" />
    <path d="M60 34h80v10H60z" />
    <path d="M64 44v18M74 44v18M84 44v18M94 44v18M104 44v18M114 44v18M124 44v18M134 44v18" />
    <path d="M56 62h88v8H56z" />
    <path d="M16 70h168v6H16zM24 76h152v6H24z" />
  </svg>
);

export const ShieldTickIcon = (p) => (
  <Svg label="Verified shield" {...p}>
    <path d="M24 6l14 5v11c0 9-6 16-14 20-8-4-14-11-14-20V11z" stroke={GR} />
    <path d="M17 24l5 5 9-10" stroke={GR} strokeWidth="2" />
  </Svg>
);

export const HandsIcon = (p) => (
  <Svg label="Namaste" {...p}>
    <path d="M24 6c-3 6-4 14-4 20 0 8 2 12 4 16 2-4 4-8 4-16 0-6-1-14-4-20z" />
    <path d="M20 14c-4 2-7 6-8 12-1 5 1 10 4 13M28 14c4 2 7 6 8 12 1 5-1 10-4 13" />
    <circle cx="24" cy="12" r="1.6" fill={R} stroke="none" />
  </Svg>
);

export const BasketIcon = (p) => (
  <Svg label="Samagri basket" {...p}>
    <path d="M10 20h28l-3 18H13z" />
    <path d="M16 20c0-6 3-10 8-10s8 4 8 10" />
    <path d="M16 26v6M24 26v8M32 26v6" />
    <circle cx="24" cy="14" r="1.6" fill={R} stroke="none" />
  </Svg>
);

export const ZeroFeeIcon = (p) => (
  <Svg label="Zero joining fee" {...p}>
    <circle cx="24" cy="24" r="16" />
    <path d="M18 17h12M18 22h12M20 17c6 4 6 10 2 14M28 22l-8 9" />
    <circle cx="35" cy="12" r="2.2" fill={R} stroke="none" />
  </Svg>
);
